<template>
  <loading v-if="!isInit" :message="'就業場所一覧の取得中...'"></loading>
  <template v-else>
    <label>就業場所を選択してください</label>
    <select v-model="selectedSyuugyouBasyoOption" @change="changeSyuugyouBasyo">
      <option v-for="syuugyoubasyo in filteredSyuugyouBasyo" :value="syuugyoubasyo"
        :selected="selectedSyuugyouBasyoOption?.koyou_id === syuugyoubasyo.koyou_id">{{ syuugyoubasyo.label }}
      </option>
    </select>
  </template>
  <div class="btn cancel" v-on:click="cancel()">キャンセル</div>
</template>


<script lang="ts">
import { useSyuugyouBasyoInit } from '@/composable/syuubyoubasyo/init';
import { SyuugyouBasyoOption } from '@/types/SyuugyouBasyo';
import { cloneDeep } from 'lodash';
import { defineComponent, onMounted, Ref, ref } from 'vue'

export default defineComponent({
  props: {
    excludeSyuugyouBasyoOptions: {
      type: Object as () => SyuugyouBasyoOption[],
      default: null
    }
  },
  emits: {
    select(value: SyuugyouBasyoOption | null) {
      return value
    },
    cancel() {
      return true
    }
  },
  setup(props, context) {
    const { syuugyouBasyoOptions, getAllSyuugyouBasyoOptions, selectedSyuugyouBasyoOption } = useSyuugyouBasyoInit()
    const isInit = ref(false)

    const filteredSyuugyouBasyo: Ref<SyuugyouBasyoOption[] | null> = ref(null);

    onMounted(async () => {
      await getAllSyuugyouBasyoOptions()
      if (syuugyouBasyoOptions.value.length > 0) {
        if (props.excludeSyuugyouBasyoOptions) {
          // オプションとして渡された就業場所を除外する
          filteredSyuugyouBasyo.value = syuugyouBasyoOptions.value.filter((option) => {
            const find = props.excludeSyuugyouBasyoOptions.find((excludeOption) => {
              return excludeOption.val === option.val
            })
            return find ? false : true
          })
        } else {
          filteredSyuugyouBasyo.value = cloneDeep(syuugyouBasyoOptions.value)
        }
      }
      isInit.value = true
    });

    const changeSyuugyouBasyo = async () => {
      context.emit('select', selectedSyuugyouBasyoOption.value);
    };

    const cancel = () => {
      context.emit('cancel')
    }

    return {
      filteredSyuugyouBasyo,
      selectedSyuugyouBasyoOption,
      changeSyuugyouBasyo,
      cancel,
      isInit
    }
  }
})
</script>

<style scoped>
@import '@scss/dialog/syuugyou-basyo.scss';
</style>